export interface Forecast {
	id: number;
	datetime: string;
}

export interface ForecastModel {
	id: number;
	version: string;
}

export interface Prediction {
	id: number;
	version: string;
}

export interface ForecastDetail extends Forecast {
	ensemble_models: ForecastModel[];
	predictions: Prediction[];
	horizont: number;
	granularity: string;
	target: string;
	model: ForecastModel;
	ensemble_version?: string;
}

export interface ForecastCurrentModel {
	ensemble_models: ForecastModel[];
	version: string;
	target: string;
}

export interface TimeseriesData {
	name: string;
	description: string;
	date: string;
	value: number;
}

interface TrendInfo {
	shift: number;
	trend: string;
	precision: number;
	recall_label: string;
	history: object;
	bound_lower: number;
	bound_upper: number;
	price: number;
	confidence: number;
}

export interface ForecastData {
	date_forecast: string;
	date_horizon_start: string;
	date_horizon_end: string;
	source_states: DataState[];
	table: any[];
	plot: string;
	safety_margin: number;
	title: string;
	forecast: ForecastDetail;
	trend_info: TrendInfo[];
	trend_dates: string[];
	mood?: Mood;
}

export interface DataState {
	source: string;
	date: string;
}

export interface DataSource {
	name: string;
	date: string;
}

export enum MoodState {
	POSITIVE = "positive",
	NEUTRAL = "neutral",
	NEGATIVE = "negative"
}

export interface Mood {
	value: MoodState;
}

export interface IndexPoint {
	date: string;
	value: number;
}

export interface MarketIndexSeries {
	name: string;
	description?: string;
	points: IndexPoint[];
}